import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  postBundleRatings,
  type PostBundleRatingsResponse,
  type PostBundleRatingsPostBody,
} from '@hungryroot/rest/api/v2/customers/[id]/bundle_ratings/post';

type UsePostBundleRatingsMutationProps<Context> = Omit<
  UseMutationOptions<
    PostBundleRatingsResponse,
    Error,
    PostBundleRatingsPostBody,
    Context
  >,
  'mutationFn'
>;

export function usePostBundleRatingsMutation<Context>(
  props?: UsePostBundleRatingsMutationProps<Context>
) {
  return useMutation({
    mutationFn: async (params: PostBundleRatingsPostBody) => {
      const res = await postBundleRatings(params);
      // returns 201
      if (res.status !== StatusCode.SuccessCreated) {
        throw res;
      }
      return res.data;
    },
    ...props,
  });
}
